// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
// import { getPerformance } from "firebase/performance";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0SP8vtHJ60aieIy76lBw8hOB3D6NxeuM",
  authDomain: "thymelakev2.firebaseapp.com",
  projectId: "thymelakev2",
  storageBucket: "thymelakev2",
  messagingSenderId: "464515653319",
  appId: "1:464515653319:web:51f173d7dffcab1fd328e2",
  measurementId: "G-1J1X98KY1F",
};

let app;

if (getApps().length === 0) {
  // Initialize Firebase
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

// Initialize Performance Monitoring and get a reference to the service
// const perf = getPerformance(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
